import { Schema } from "@comparaonline/products-schema";
import get from "lodash.get";

import { IFlagProps } from "@comparaonline/ui-offer-card";
import { CardConfig, IWidgets } from "../../../../config/widgets";
import { useAppContext } from "../../../lib/appContext";
import { ENTITY_CODE_FREE_INSTALLMENT_RIBBON } from "../../constants";

export const getCardConfig = (widgets: IWidgets) => get(widgets, "card", null);

export const findConfigByProductId = (productId: number, config: CardConfig) => {
  const productIds = config.productIds;
  if (productIds.length === 0) {
    return true;
  }
  return productIds.indexOf(productId) > -1 ? Boolean(config.flagUrl) : false;
};

export const makeFlagProps = (src: string, alt?: string) => ({
  imgProps: {
    alt,
    src
  }
});

export type IFlagPropsOption = IFlagProps | undefined;

export const buildFlagProps = (productId: number, cardConfig: CardConfig[]): IFlagPropsOption => {
  const configProduct = cardConfig.find(config => findConfigByProductId(productId, config));
  return configProduct ? makeFlagProps(configProduct.flagUrl!, configProduct.name) : undefined;
};

export const isAttributeEnabled = (attribute: Schema.ProductListProductAttribute | null) =>
  Boolean(attribute && attribute.enabled);

export const getFreeInstallmentFlag = (offer: Schema.ProductListProduct) => {
  if (offer && Array.isArray(offer.productAttributes)) {
    return offer.productAttributes
      .filter(isAttributeEnabled)
      .find(attr => Boolean(attr && attr.entity.code === ENTITY_CODE_FREE_INSTALLMENT_RIBBON));
  }
  return undefined;
};

export const isValidFreeInstallmentFlag = (attribute: Schema.ProductListProductAttribute) =>
  Boolean(attribute.value && attribute.value.src);
export const getFlagPropsFromOffer = (product: Schema.ProductListProduct) => {
  const flagInstallment = getFreeInstallmentFlag(product);
  return flagInstallment && isValidFreeInstallmentFlag(flagInstallment)
    ? makeFlagProps(flagInstallment.value.src, flagInstallment.value.alt)
    : undefined;
};

export const useFlagProps = () => {
  const appContext = useAppContext();
  return (productData: Schema.ProductListProduct) => {
    const { widgets } = appContext.businessUnitConfig;
    const cardConfig = getCardConfig(widgets);
    let flagProps: IFlagPropsOption;

    if (Boolean(cardConfig)) {
      flagProps = buildFlagProps(parseInt(productData.id, 10), cardConfig!);
    }

    const flagInstallmentProps = getFlagPropsFromOffer(productData);

    if (flagInstallmentProps) {
      flagProps = flagInstallmentProps;
    }

    return flagProps;
  };
};
